import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {DeleteModal} from "components";
import {MainInfo} from "fragments";
import {AddPayer} from "./fragments";
import {emptyState, payersBody, payersHead} from "./constants";
import {FindSuccess, limit, renderPayerName, useModal} from "utils";
import {httpRequestsOnSuccessActions, payerActions} from "store";
import {PayersSingle} from "./payersSingle";

const ACTION_TYPE = "GET_PAYERS";
const ACTION_DELETE = "DELETE_PAYER";
const ACTION_CHANGE_STATUS = "CHANGE_STATUS_PAYER";

export const Payers = () => {
    const payersList = useSelector((state) => state.payers?.payersList);
    const dispatch = useDispatch();
    const location = useLocation();
    const {openModal, close} = useModal();
    const successChangeStatus = FindSuccess(ACTION_CHANGE_STATUS);
    const info = location?.state;

    const getPayers = (noLoad) => {
        const params = {
            ...info,
        };
        params.skip = info?.skip ? info?.skip : 0;
        params.limit = limit;

        dispatch(payerActions.getPayers(params, noLoad));
    }

    useEffect(() => {
        if (successChangeStatus?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_CHANGE_STATUS))
            getPayers(true)
        }
    }, [successChangeStatus]);

    useEffect(() => {
        getPayers()
    }, [info]);

    const addPayer = (item) => {
        openModal(<AddPayer info={item} afterSuccess={() => getPayers(true)}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 482
        });
    };

    const handleDelete = (item) => {
        openModal(
            <DeleteModal
                handleDelete={() => {
                    dispatch(payerActions.deletePayer(item?.id));
                }}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${renderPayerName(item)} ?`}
                afterSuccess={() => {
                    getPayers(true);
                    close();
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const handleClickRow = (item) => {
        openModal(<PayersSingle item={item} afterSuccess={() => getPayers(true)}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1236
        });
    };

    return (
        <div className="payers-page-wrapper">
            <MainInfo
                buttonText="Add Payer"
                headerTable={payersHead()}
                bodyTable={payersBody({
                    handleDelete,
                    handleEit: (item) => addPayer(item),
                })}
                clickToAddButton={() => addPayer()}
                listTable={payersList?.payers}
                listCountTable={payersList?.count}
                actionType={ACTION_TYPE}
                handleClickRow={handleClickRow}
                emptyState={emptyState(addPayer)}
            />
        </div>
    );
};
